import productcategories from "./productcategories";
import axios from 'axios';
// initial state

const state = () => ({
    meta : [],
    products : [],
    addNew: false,
    // derzeit noch benötigt, da diese columns liste zum laden und soriteren mit verwendet wird eigentlich über die table preferences zu laden...
    columns : [
        {
            key : "name",
            label : "name",
            display : true,
            table: "products",
            direction : "ASC",
            direction_pos: 0,
        },
        {
            key:"product_number",
            label: "number",
            display : true,
            table: "products",
            direction : "ASC",
            direction_pos: 0,
        },
        {
          key:"certificate",
          label: "certificate",
          display : true,
        },
        {
          key:"quality",
          label: "quality",
          display : true,
        },
        {
          key:"assortment",
          label: "assortment",
          display : true,
        },
        {
          key:"wood_type",
          label: "wood_type",
          display : true,
        },
        {
          key:"degree_of_processing",
          label: "degree_of_processing",
          display : true,
        },
        {
          key:"treatment",
          label: "treatment",
          display : true,
        },
        {
          key:"dimensionList",
          label: "dimensionList",
          display : true,
          displayType: 'popover'
        }

        // 'quality', 'certificate', 'assortment', 'wood_type', 'degree_of_processing'
    ],
    loaded :false,
    isSaving : false,
    pagination : {
        currentPage: 1,
        totalPageCount: 1,
    },
    take: 25,
    skip: 0,
    search: "",
    fetchActive: 0,
    workingOn : [],
    languages : [],
    properties : [],
    formulas : [],
    productTypes : [],
    units : [],
    productTypes : [],
    propertyIsSaving : false,
    productDimensions : [],
    additional : [],
})

const getters = {
    getById :(state) => (id) =>{
        return state.products[state.companies.findIndex(item => item.id == id)]
    },

}

// actions
const actions = {
    async update({commit, state, rootState}, data) {
        commit("isSaving", true);
        commit("workingOn", data.product.id);
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/products/" + data.product.id, data).then(response => {
            // commit("update", response.data.data);
        });
        commit("doneWorkingOn", data.product.id);
        commit("isSaving", false);
    },

    async store({commit, state, rootState}, data) {
        commit("isSaving", true);
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/products", data).then(response => {
            // commit("store", response.data.data);
        })
        commit("isSaving", false);
    },

    async load({commit, state, rootState}, page = 1) {
        commit("skip", (page - 1) * state.take);
        var pagesize = state.pagination.pagesize;

        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/products", {
            params: {page: page, pagesize: pagesize, fetchActive: state.fetchActive, search : state.search, take: state.take, skip: state.skip, table_columns : state.columns}
        }).then((response) => {
            commit("setProducts", response.data.data)
            commit("setMeta", response.data.meta);
            commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
            commit("loaded", true);
        })
    },
    async export({state, rootState}){

        return axios.put(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/products", {
                export:true, search : state.search, table_columns : state.columns
        }, { responseType: 'blob' });
    },

    async loadLanguages({commit, state, rootState}, data) {
        await axios.get(rootState.settings.url + "/api/v1/getLanguages").then(response => {
            commit("setLanguages", response.data);
        })
    },

    async delete({commit, state, rootState}, data) {
        if (data.data.url !== undefined && data.data.ids.length > 0) {
            for (var i = 0; i < data.data.ids.length; i++) {
                var url = data.data.url + "/" + data.data.ids[i];
                await axios.delete(url).then(response => {
                    commit("deleteProduct", data.data.ids[i]);
                }).catch(error => {
                   console.log(error.response.data.message);
                });
            }
        }
    },

    async destroyProperty({commit, state, rootState}, data) {
        var url = rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/destroyProperty/" + data.id;
        await axios.delete(url).then(response => {
            commit("deleteProperty", data);
        }).catch(error => {
            console.log(error.response.data.message);
        });


    },

    async storeProperty({commit, state, rootState}, data) {
        commit("propertyIsSaving", true);
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/storeProperty", data).then(response => {
            commit("updateProperty", response.data.data);
        })
        commit("propertyIsSaving", false);
    },
    async loadFormulas({commit, state, rootState}, data) {
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/loadFormulas").then(response => {
            commit("setFormulas", response.data);
        })
    },

    async loadProductTypes({commit, state, rootState}, data) {
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/loadProductTypes").then(response => {
            commit("loadProductTypes", response.data);
        })
    },

    async loadUnits({commit, state, rootState}, data) {
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/loadUnits").then(response => {
            commit("setUnits", response.data);
        })
    },

    async getProductById({commit, state, rootState}, data) {
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/getProductById/"+data.id).then(response => {
        })
    },
}

// mutations
const mutations = {
    setSearch(state, value){
        state.search = value.trim();
    },
    clean(state) {
        state.products = [];
        state.loaded = false;
        state.workingOn = [];
        state.search = "";
    },
    update(state, data) {
        var index = state.products.findIndex(item => item.id == data.id);
        if(index >= 0) {
            state.products[index] = data;
        }
    },
    store(state, data) {
        state.products.unshift(data);
    },
    loaded(state, status) {
        state.loaded = status;
    },
    setProducts(state, products) {
      //TODO: anders lösen
      for (const i in products) {
        let dimensionList = '<ul class="whitespace-nowrap space-y-2">';
        products[i].properties.dimension.forEach(dimension => {
          dimensionList+= '<li>';
          dimensionList+= dimension;
          dimensionList+= '</li>';
        });
        dimensionList+= '</ul>';
        products[i].dimensionList = dimensionList;
      }

      state.products = products;
    },
    setMeta(state, data) {
        state.meta = data;
    },
    workingOn(state, id) {
        if (state.workingOn.findIndex(item => item == id) < 0) {
            state.workingOn.push(id);
        }
    },
    doneWorkingOn(state, id) {
        var index = state.workingOn.findIndex(item => item == id);
        if (index >= 0) {
            state.workingOn.splice(index, 1);
        }
    },
    isSaving(state, status) {
        state.isSaving = status;
    },
    deleteProduct(state, id) {
        var index = state.products.findIndex(item => item.id == id);
        if (index >= 0) {
            state.products.splice(index, 1);
        }
    },
    deleteProperty(state, data) {
        var index = state.properties[data.propertyTypeId]['list'].findIndex(item => item.id == data.id);
        if (index >= 0) {
            state.properties[data.propertyTypeId]['list'].splice(index, 1);
        }

        var index = state.properties[data.propertyTypeId]['selectList'].findIndex(item => item.value == data.id);
        if (index >= 0) {
            state.properties[data.propertyTypeId]['selectList'].splice(index, 1);
        }
    },
    setLanguages(state, data) {
        state.languages = data;
    },
    setProperties(state, data) {
        state.properties = data;
    },
    storeProperty(state, data) {
        state.properties.unshift(data);
    },
    updateProperty(state, data) {
        // update property in der allgemeinen liste
        if (data.saveType == "store") {
            state.properties[data.propertyTypeId].list.push(data.property);
            state.properties[data.propertyTypeId].selectList.push(data.selectProperty);
        }

        if (data.saveType == "update") {
            var index = state.properties[data.propertyTypeId].list.findIndex(item => item.id == data.property.id);
            if(index >= 0) {
                state.properties[data.propertyTypeId].list[index] = data.property;
            }

            var index = state.properties[data.propertyTypeId].selectList.findIndex(item => item.value == data.selectProperty.value);
            if (index >= 0) {
                state.properties[data.propertyTypeId].selectList[index] = data.selectProperty;
            }
        }
    },


    setFormulas(state, data) {
        state.formulas = data;
    },

    loadProductTypes(state, data) {
        state.productTypes = data;
    },

    setUnits(state, data) {
        state.units = data;
    },

    setProductDimensions(state, data) {
        state.productDimensions = data;
    },

    pagination(state, object) {
        state.meta.pagination = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.pagination.total / state.take);
        state.pagination.total = state.meta.pagination.total
        state.pagination.pagesize = state.take
    },

    skip(state, skip) {
        state.skip = skip;
    },

    propertyIsSaving(state, status) {
        state.propertyIsSaving = status;
    },

    setAdditional(state, data) {
        state.additional = data;
    },
    updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    },
    updateAllColumns(state, columns){
        state.columns = columns;
    },
    setFetchActive(state, data) {
      state.fetchActive = data;
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        // productcategories
    }
}
